import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { VENDOR_REVENDORIZATIONS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchVendorRevendorizations = ({
  page = 1,
  pageSize = 20
}) => {
  const searchParams = new URLSearchParams({
    page,
    pageSize
  }).toString();

  return useQuery({
    queryKey: [VENDOR_REVENDORIZATIONS_QUERY_KEY, page, pageSize],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: `/api/vendor-revendorizations?${searchParams}`,
        method: "GET"
      });
    },
    keepPreviousData: true
  });
};
